export default __webpack_public_path__ + "static/media/college.9609529c.png";